import { LobbyImage } from '@colonist/types';
import { UIMMatchmakingSearchingView } from './UIMMatchmakingSearchingView.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMMatchmakingSearchingClassic4PView extends UIMMatchmakingSearchingView {
    addTitle() {
        super.addTitle();
        this.setTimeElapsedCounter();
    }
    constructor(matchmakingController, matchType){
        const loadingText = {
            key: 'strings:homePage.matchmakingPopup.searchingForOpponents'
        };
        const isRanked = matchType == MatchmakingMatchTypes.RankedClassic4P;
        const player4Ranked = {
            key: 'strings:homePage.matchmakingPopup.ranked4Player.title'
        };
        const player4Unranked = {
            key: 'strings:homePage.unranked.4Player'
        };
        const title = isRanked ? player4Ranked : player4Unranked;
        const imageSrc = isRanked ? LobbyImage.GameModeRanked4P : LobbyImage.GameModeBase;
        super(matchmakingController, title, imageSrc, loadingText, matchType);
    }
}
